export const JOURNALIST_PROMPT_KEYS = [
    "shared.methodology",
    "role.extraction",
    "role.digest",
    "role.synthesis",
    "role.knowledge_query",
];
/**
 * Whether a layer may be edited from a customer surface. Derived, not served:
 * the platform layer carries the `author_type` trust boundary, so a layer
 * below it must never be able to rewrite the rule that constrains it.
 */
export function isClaudeMdLayerEditable(scope) {
    return scope !== "platform";
}
//# sourceMappingURL=hub-client.js.map